<template>
  <Dialog
    v-if="props.consultantId && rep"
    v-model:visible="showPopup"
    :show-header="false"
    :modal="true"
    :dismissable-mask="true"
    @after-hide="router.push({ query: {} })"
  >
    <div class="flex-column gap-sm p-4xl-x p-xmd-y text-center mobile:p-1xl-x">
      <ThumbnailedImage :images="rep.images" :alt="`${rep.name}`" />
      <div class="pa-p1">
        <div>
          {{ rep.name }}
        </div>
        <div>{{ rep.rep_number }}</div>
      </div>
      <h2 class="pa-h2 pa-pink">Welcome to my site</h2>
      <div class="flex-row flex-center gap-md">
        <Button class="grey">
          <RouterLink
            :to="{
              name: 'consultant',
              params: { consultantId: props.consultantId },
            }"
          >
            About Me
          </RouterLink>
        </Button>
        <Button class="grey" @click="closePopup"> Shop </Button>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import ThumbnailedImage from "@/components/ThumbnailedImage.vue";
import { useRepsStore, useUserStore } from "@/stores/user";
import { getConsultant } from "@/utils/reps";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";

const props = defineProps<{
  consultantId: string | undefined;
}>();

const router = useRouter();
const reps = useRepsStore();
const user = useUserStore();

const showPopup = ref(true);

const rep = computed(() => {
  return reps.list.find((r) => `${r?.rep_number}` === `${props.consultantId}`);
});

watch(
  () => props.consultantId,
  async () => {
    if (props.consultantId) {
      await getConsultant(props.consultantId);
    }
  },
);

onMounted(async () => {
  if (props.consultantId) {
    await getConsultant(props.consultantId);
  }
});

function closePopup() {
  showPopup.value = false;
  if (rep.value?.rep_number) {
    user.changeRep(rep.value.rep_number);
  }
}
</script>

<style scoped></style>
